import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import moment from 'moment';
class TimeSlotRowHeader extends Component {

  renderTds(days, numDaysShow, page, numDays) {
    // TODO: this needs to be passed in because this logic should be handled by
    // the cal and passed to this component
    let temp = [];
    let start = 0 + (page*numDaysShow);
    let end = start + numDaysShow;

    while (end > numDays) {
      end--;
      start--;
    }

    for (let i=start; i<end; i++) {
      temp.push(days[i]);
    }

    return temp;
  }

  formatDate(day) {
    const momentStart = moment(day.dateString);
    const date = momentStart.format('ddd DD');

    return date;
  }

  render() {
    const classes = 'hg-TimeSlotRowHeader';

    const {
      children,
      className,
      days,
      numDaysShow,
      numDays, // maxDays
      page
    } = this.props;

    if (!days || !days.length) return null;

    return (
      <tr {...this.props} className={classNames(className, classes)}>
          {this.renderTds(days, numDaysShow, page, numDays).map((day, i) =>
            <th key={i} day={day}><div className="s-install--content x-body2">{this.formatDate(day)}</div></th>
          )}
        {children}
      </tr>
    );
  }
}

TimeSlotRowHeader.propTypes = {
    children: PropTypes.node,
    days: PropTypes.array.isRequired,
    className: PropTypes.string,
    startDate: PropTypes.string.isRequired,
    numDaysShow: PropTypes.number.isRequired,
    numDays: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired
};

export default TimeSlotRowHeader;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/src/TimeSlotRowHeader/TimeSlotRowHeader.jsx
 **/